// From package.json
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import { createApp } from 'vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import xss from 'xss';

// Local imports
import './utility/polyfills';
import initializeEnvironment, { isInLocalEnvironment } from './environment';
import store from './vuex/store';
import App from './App.vue';
import router from './router/router';
import i18n from './locales/i18n';
import AuthService from './auth/AuthService';
import axiosInterceptor from './utility/axios';

// Global styles
import './assets/scss/main.scss';
import './assets/ok-styles/ok-global.scss';

// Import utility functions
import * as utilities from './utility';

function initializeApplication(logout, updateToken) {
  router.beforeEach((unusedTo, unusedFrom, next) => {
    updateToken().then(next);
  });

  const app = createApp({
    data() {
      return {
        logout,
        updateToken,
      };
    },
    template: '<App :logout="logout" :updateToken="updateToken"/>',
  });

  app.config.globalProperties.$minside = {};
  Object.entries(utilities).forEach(([key, value]) => {
    app.config.globalProperties.$minside[key] = value;
  });
  app.config.globalProperties.$filters = {
    truncate(value, length) {
      if (value.length > length) {
        return `${value.substring(0, length)}...`;
      }
      return value;
    },
  };

  app.config.globalProperties.$sanitize = xss;
  app.config.compilerOptions.whitespace = 'preserve';
  app.config.performance = true;
  app.component('App', App);
  app.use(Toast);
  app.use(router);
  app.use(i18n);
  app.use(store);
  app.mount('#app');
}

axiosInterceptor();

if (window.location.href.includes('minside-tjenester')) {
  window.location.href = window.location.href.replace('minside-tjenester', 'minside');
} else {
  initializeEnvironment()
    .then(() => {
      const auth = new AuthService();
      const { logout, updateToken } = auth;
      auth
        .init()
        .then(() => {
          if (auth.keycloak.authenticated || isInLocalEnvironment()) {
            initializeApplication(logout, updateToken);
          } else {
            console.log('Bruker er ikke autentisert');
          }
        })
        .catch(() => {
          console.error('Feilet å initialisere AuthService');
        });
    })
    .catch(console.error);
}
